/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

const sentryConfig = {
  dsn: SENTRY_DSN,
  enabled: 'string' === typeof SENTRY_DSN,
};

export { sentryConfig };
